var app = angular.module('directives.timer', []);

require('./directives/timer.js');
require('./templates/timer.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/timer/index.js
 ** module id = 238
 ** module chunks = 1
 **/